import apiClient from './meta-client';
import type { UtilityTemplateResolutionEntry } from '@/types/broadcast';

// ========== ESTEIRA DE UTILITY (pack reutilizável de múltiplos templates) ==========
// PRD-esteira-multi-template-utility.md — entidade persistida, builder dedicado
// fora do wizard de broadcast. Ver ms-meta-api: routes/meta/utility_esteira_route.py

export interface UtilityEsteira {
    id: number;
    user_id: number;
    name: string;
    page_ids: string[];
    /**
     * Revisão v3: cada entrada carrega seu próprio auxiliar opcional via
     * `secondary_group_id` — não existe mais auxiliar único de nível superior.
     */
    template_resolution: UtilityTemplateResolutionEntry[];
    created_at: string;
    updated_at: string;
}

export interface CreateUtilityEsteiraRequest {
    name: string;
    page_ids: string[];
    template_resolution: UtilityTemplateResolutionEntry[];
}

export type UpdateUtilityEsteiraRequest = Partial<CreateUtilityEsteiraRequest>;

export const createEsteira = async (data: CreateUtilityEsteiraRequest): Promise<UtilityEsteira> => {
    const response = await apiClient.post<UtilityEsteira>('/meta/utility-esteiras', data);
    return response.data;
};

export const listEsteiras = async (): Promise<UtilityEsteira[]> => {
    const response = await apiClient.get<UtilityEsteira[]>('/meta/utility-esteiras');
    return response.data;
};

export const getEsteira = async (id: number): Promise<UtilityEsteira> => {
    const response = await apiClient.get<UtilityEsteira>(`/meta/utility-esteiras/${id}`);
    return response.data;
};

export const updateEsteira = async (
    id: number,
    data: UpdateUtilityEsteiraRequest
): Promise<UtilityEsteira> => {
    const response = await apiClient.put<UtilityEsteira>(`/meta/utility-esteiras/${id}`, data);
    return response.data;
};

export const duplicateEsteira = async (id: number): Promise<UtilityEsteira> => {
    const response = await apiClient.post<UtilityEsteira>(`/meta/utility-esteiras/${id}/duplicate`);
    return response.data;
};

export const deleteEsteira = async (id: number): Promise<void> => {
    await apiClient.delete(`/meta/utility-esteiras/${id}`);
};
